export enum ClientEmployeeTableColumns {
  name = "name",
  email = "email",
  appsUsed = "appsUsed",
  lastActivity = "lastActivity",
}

export const CLIENT_EMPLOYEE_TABLE_COLUMN_LABELS: Record<ClientEmployeeTableColumns, string> = {
  [ClientEmployeeTableColumns.name]: "Name",
  [ClientEmployeeTableColumns.email]: "Email",
  [ClientEmployeeTableColumns.appsUsed]: "Resource groups used",
  [ClientEmployeeTableColumns.lastActivity]: "Last activity",
};

export const DEFAULT_CLIENT_EMPLOYEE_TABLE_COLUMN_SETTINGS: Record<ClientEmployeeTableColumns, boolean> = {
  [ClientEmployeeTableColumns.name]: true,
  [ClientEmployeeTableColumns.email]: true,
  [ClientEmployeeTableColumns.appsUsed]: true,
  [ClientEmployeeTableColumns.lastActivity]: true,
};

export const DEFAULT_CLIENT_EMPLOYEE_TABLE_COLUMN_ORDER: ClientEmployeeTableColumns[] = [
  ClientEmployeeTableColumns.name,
  ClientEmployeeTableColumns.email,
  ClientEmployeeTableColumns.appsUsed,
  ClientEmployeeTableColumns.lastActivity,
];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> => CLIENT_EMPLOYEE_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> => DEFAULT_CLIENT_EMPLOYEE_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] => DEFAULT_CLIENT_EMPLOYEE_TABLE_COLUMN_ORDER;